// extracted by mini-css-extract-plugin
export var messageSideLeft = "_jf-1";
export var stateContainer = "_jf-0";